import React from 'react';

import RichTextEditorDebugger from '../../RichTextEditor/components/RichTextEditorDebugger';

import styles from './Discourse.module.scss';

const DiscourseDebugger = ({ state }) => {
  return (
    <RichTextEditorDebugger
      state={state}
      editableContentId={styles.mainSection}
      stateDisplayClassName={styles.stateDisplay}
    />
  );
};

export default DiscourseDebugger;
